import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { firstValueFrom } from 'rxjs'
import { environment } from '@env'
import {
  Category,
  GetCategoriesRequest,
  GetCategoriesResponse,
  SaveCategoryRequest,
  SaveCategoryResponse,
  UpdatePositionRequest,
} from '@models'

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  private readonly baseUrl = `${environment.api.baseUrl}/product-structure/v1/categories`

  constructor(private http: HttpClient) {}

  async getAll(params?: GetCategoriesRequest): Promise<GetCategoriesResponse> {
    let httpParams = new HttpParams()

    if (params) {
      if (params.page !== undefined) httpParams = httpParams.set('page', params.page.toString())

      if (params.pageSize !== undefined) httpParams = httpParams.set('pageSize', params.pageSize.toString())

      if (params.name) httpParams = httpParams.set('name', params.name)

      if (params.subGroupId !== undefined) httpParams = httpParams.set('subGroupId', params.subGroupId.toString())
    }

    const response = await firstValueFrom(this.http.get<GetCategoriesResponse>(this.baseUrl, { params: httpParams }))
    return response
  }

  async getById(id: string): Promise<Category> {
    const response = await firstValueFrom(this.http.get<Category>(`${this.baseUrl}/${id}`))
    return response
  }

  async create(payload: SaveCategoryRequest): Promise<SaveCategoryResponse> {
    const response = await firstValueFrom(this.http.post<SaveCategoryResponse>(this.baseUrl, payload))
    return response
  }

  async update(id: string, payload: SaveCategoryRequest): Promise<SaveCategoryResponse> {
    const response = await firstValueFrom(this.http.put<SaveCategoryResponse>(`${this.baseUrl}/${id}`, payload))
    return response
  }

  async delete(id: string): Promise<void> {
    const response = await firstValueFrom(this.http.delete<void>(`${this.baseUrl}/${id}`))
    return response
  }

  async updatePosition(payload: UpdatePositionRequest[]): Promise<void> {
    const response = await firstValueFrom(this.http.patch<void>(`${this.baseUrl}/position`, payload))
    return response
  }
}
